import { variables } from './_variables.js';
import { lenisInstance } from './_lenis.js';  // Lenisインスタンスをインポート

export const subMenu = (option = {}) => {
  const triggers = document.querySelectorAll('[data-menu-trigger]');
  const submenuContent = document.querySelector('.submenu');
  const pcMenuNav = document.querySelector('.js-pc-menu-nav .pc-menu-nav');
  let isMenuOpen = false;
  let { isMobile } = variables();

  if (!submenuContent || !triggers.length) return;

  // リサイズ時にisMobileの値を更新する関数
  const updateMobileState = () => {
    const vars = variables();
    isMobile = vars.isMobile;
  };

  // スクロールロック関数を修正
  const toggleScrollLock = (isLock, isPCMenu = false) => {
    // PCメニューの場合は単純にoverflow制御のみ行う
    if (isPCMenu) {
      document.body.style.overflow = isLock ? 'hidden' : '';
      return;
    }

    // SPメニューの場合は従来通りの処理
    if (isLock) {
      const scrollPosition = window.pageYOffset;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollPosition}px`;
      document.body.style.width = '100%';
      document.body.classList.add('is-scroll-lock');
    } else {
      const scrollPosition = Math.abs(parseInt(document.body.style.top || '0'));
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, scrollPosition);
      document.body.classList.remove('is-scroll-lock');
    }
  };

  // スクロールイベントハンドラ
  let lastScrollTop = 0;
  const handleScroll = () => {
    if (!isMenuOpen) return; // メニューが閉じている場合は何もしない
    
    // PCメニューが開いている場合はスクロールによる非表示を防ぐ
    if (!isMobile && document.body.classList.contains('is-pc-menu-open')) {
      return;
    }

    const st = window.scrollY || document.documentElement.scrollTop;
    if (Math.abs(lastScrollTop - st) <= 5) return;

    closeAllSubmenus();
    lastScrollTop = st <= 0 ? 0 : st;
  };

  // PCメニュー用のスクロールロック関数を分離
  const togglePCMenuScrollLock = (isLock) => {
    if (isLock) {
      document.body.style.overflow = 'hidden';
      // 必要に応じてパディングを追加してスクロールバーの幅を補正
      document.body.style.paddingRight = `${window.innerWidth - document.documentElement.clientWidth}px`;
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }
  };

  // コメント：モバイルメニューとPCメニュー両方のスクロールを有効にする
  // モバイルメニューのスクロール有効化
  submenuContent.addEventListener('wheel', (e) => {
    e.stopPropagation();  // Lenisのスクロール制御を停止
  });

  // PCメニューのスクロール有効化
  if (pcMenuNav) {
    pcMenuNav.addEventListener('wheel', (e) => {
      e.stopPropagation();  // Lenisのスクロール制御を停止
    });
  }

  // サブメニューの開閉を制御する関数
  const toggleSubmenu = (trigger, isOpen) => {
    const target = trigger.dataset.menuTrigger;
    
    // 基本的なトグル処理
    trigger.classList.toggle('is-active', isOpen);
    submenuContent.classList.toggle('is-open', isOpen);
    submenuContent.classList.toggle('is-close', !isOpen);
    
    if(option.isBlur) {
      document.body.classList.toggle('is-blur', isOpen);
    }

    // PCメニューの場合
    if (!isMobile && target === 'pcmenu') {
      pcMenuNav.classList.toggle('is-open', isOpen);
      pcMenuNav.classList.toggle('is-close', !isOpen);
      document.body.classList.toggle('is-pc-menu-open', isOpen);
      
      // Lenisの制御
      if (lenisInstance) {
        isOpen ? lenisInstance.stop() : lenisInstance.start();
      }
    }

    // スマホメニューの場合
    if (isMobile && (target === 'sp-menu' || target === 'spmenu')) {
      toggleScrollLock(isOpen, false);
      if(target === 'spmenu') {
        document.body.classList.toggle('is-sp-menu-color', isOpen);
      }
    }
    
    submenuContent.querySelectorAll('[data-menu-content]').forEach(content => {
      setTimeout(() => content.classList.toggle('is-open', isOpen && content.dataset.menuContent === target), 250);
    });
    
    isMenuOpen = isOpen;
  };

  // すべてのサブメニューを閉じる関数
  const closeAllSubmenus = () => {
    triggers.forEach(trigger => toggleSubmenu(trigger, false));
  };

  // クリックイベントハンドラ
  const handleClick = (event) => {
    const trigger = event.currentTarget;
    const isActive = trigger.classList.contains('is-active');
    const target = trigger.dataset.menuTrigger;

    // 他のトリガーを非アクティブにする
    triggers.forEach(t => t !== trigger && toggleSubmenu(t, false));

    // クリックされたトリガーの状態を切り替える
    toggleSubmenu(trigger, !isActive);

    // メニューが閉じられた場合、遅延してクラスを削除
    if (isActive) {
      // サブメニューのクラス削除
      setTimeout(() => submenuContent.classList.remove('is-close'), 1000);
      
      // PCメニューの場合、pcMenuNavのクラスも削除
      if (!isMobile && target === 'pcmenu') {
        setTimeout(() => pcMenuNav.classList.remove('is-close'), 1000);
      }
    }

    event.stopPropagation();
  };

  // ドキュメント全体のクリックイベントハンドラ
  const handleDocumentClick = (event) => {
    if (isMenuOpen && !submenuContent.contains(event.target)) {
      closeAllSubmenus();
    }
  };

  // イベントリスナーの設定
  triggers.forEach(trigger => trigger.addEventListener('click', handleClick));
  document.addEventListener('click', handleDocumentClick);
  
  // PCの場合のみスクロールイベントを設定
  const updateScrollListener = () => {
    if (!isMobile) {
      window.addEventListener('scroll', handleScroll);
    } else {
      window.removeEventListener('scroll', handleScroll);
    }
  };

  // 初期設定
  updateScrollListener();
  
  // リサイズ時の処理を追加
  window.addEventListener('resize', () => {
    updateMobileState();
    updateScrollListener();
  });
};
